import React from 'react';
import {
    WidgetDate,
    WidgetTime,
    WidgetLinkTruncatedText,
} from '../../../../components';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { downloadWithNameFromUrl } from '../../../../helpers';

export default function SummariesColumns ({ download }) {
    const { t } = useTranslation();
    return [{
        dataField: 'id_statement',
        text: t('summary.table.columns.id'),
        sort: false,
        align: 'center',
        headerAlign: 'center',
        headerClasses: 'clientsColumnsMC_headers--title',
    },
    {
        dataField: 'period',
        text: t('summary.table.columns.period'),
        align: 'center',
        headerAlign: 'center',
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => {
            return (
                <span>
                    {cellContent ? moment(cellContent).format('DD/MM/YYYY') : null}
                </span>
            );
        }
    },
    {
        dataField: 'pdf',
        text: t('summary.table.columns.pdf'),
        headerClasses: 'clientsColumnsMC_headers--title',
        align: 'center',
        headerAlign: 'center',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => (<span onClick={() => downloadWithNameFromUrl(cellContent, `Resumen ${moment(row.period).format('DD/MM/YYYY')}.pdf`)} style={{ cursor: 'pointer' }}>Descargar Resumen</span>)
    },
    {
        dataField: 'emision_date',
        text: t('summary.table.columns.date'),
        headerClasses: 'clientsColumnsMC_headers--title',
        align: 'center',
        headerAlign: 'center',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => {
            return (
                <>
                    <WidgetDate date={new Date(cellContent)} />
                    <span> </span>
                    {(cellContent ? <WidgetTime date={new Date(cellContent)} /> : null)}
                </>
            );
        }
    },

    {
        dataField: 'document',
        text: t('summary.table.columns.document'),
        sort: false,
        align: 'center',
        headerClasses: 'clientsColumnsMC_headers--title',
        headerAlign: 'cemter',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => {
            return <WidgetLinkTruncatedText to={`/clients/details/${row.id_user}`} text={cellContent || 'S/D'} truncated='false'/>;
        }
    },
    {
        dataField: 'last_four',
        text: t('summary.table.columns.lastFour'),
        align: 'center',
        headerAlign: 'center',
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => (<WidgetLinkTruncatedText to={`/clients/card/${row.id_user}`} text={cellContent || '-'} truncated='false'/>)
    },

    ];
}
